import axios from "axios";
import { FaCircle } from "react-icons/fa";
import { GoCalendar } from "react-icons/go";
import Tooltip from "@mui/material/Tooltip";
import { IoEyeOutline } from "react-icons/io5";
import CONSTANTS from "src/components/services/api";
import CustomBadge from "src/components/atoms/Badge";
import { AiOutlineEyeInvisible } from "react-icons/ai";
import { useContext, useEffect, useState } from "react";
import { MdOutlineArrowForwardIos } from "react-icons/md";
import { MdOutlineLocalPostOffice } from "react-icons/md";
import ProgressBars from "src/components/atoms/ProgressBar";
import PrimaryButton from "../../atoms/buttons/PrimaryButton";
import { AdminDashboardContext, MyContext } from "src/components/Context/MyContext";
import Cookies from "js-cookie";

const ChatCard = ({ data, handler = () => { }, btnTitle, setRatingPendingBox = () => { }, setRatingCardData = () => { } }) => {
  const [showProgressBar, setShowProgressBar] = useState(false);
  const [progressPercentage, setProgressPercentage] = useState("");
  const BearerToken = Cookies.get("Token");

  async function getProgressdetails(id) {
    setShowProgressBar(true);
    try {
      const progressPercentage = await axios.get(`${CONSTANTS.API_BASE}/my_program_prod/${id}`, {
        headers: {
          Authorization: BearerToken,
        },
      });
      setProgressPercentage(progressPercentage?.data?.data);
    } catch (error) {
      console.log("Error >>>", error);
    }
  }

  const handleManage = () => {
    window.open(data?.manageDetails, "_target");
  };

  const { selectedChat, setSelectedChat, deeplinkId, setDeeplinkId } = useContext(MyContext);
  const { otherSide_status, setNewMessageOn, newMessageOn, onlineUserList } = useContext(AdminDashboardContext);
  const showChat = JSON.parse(localStorage.getItem("showChat"));

  useEffect(() => {
    if (deeplinkId && (String(deeplinkId) === String(data?._id))) {
      setSelectedChat(data);
      localStorage.setItem("showChat", JSON.stringify(data));
      localStorage.setItem("my-message", JSON.stringify([]));
      setDeeplinkId(null);
    }
  }, [deeplinkId]);

  const chatVisible = (complete, rating) => {
    if (complete && rating) {
      return true;
    } else if (!complete && rating) {
      return true;
    } else if (!complete && !rating) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <div
      className={`border rounded-[10px] border-[#979797] flex w-full  ${selectedChat?._id === data?._id ? "bg-[#FFFFD9]" : "bg-[#FFFFFF]"
        } h-full shadow-sm overflow-hidden my-4 border-opacity-25 hover:bg-[#FFFFD9]`}
    >
      <div className="bg-[#D9FFCC] w-[8px] "></div>
      <div className="flex-1 w-full p-3">
        <div className="flex justify-between">
          <h1 className="text-sm font-bold flex flex-col lg:flex-row">
            {data?.username} <span className="text-[10px] lg:ml-2 text-bold">#{data?._id}</span>
          </h1>
          {/* program should be live  */}
          {data.is_live ? <FaCircle color={`${Array.isArray(onlineUserList) ? onlineUserList.includes(data?.user_id) ? "#2BE71D" : "#8F9E8E" : null}`} size={10} /> : <FaCircle color={"#8F9E8E"} size={10} />}
        </div>
        <div className="flex items-center justify-between">
          <h5 className="text-xs font-medium text-[rgba(118,118,124,0.8)] mt-[10px]">{data?.program}</h5>
          <CustomBadge
            badgeContent={data?.unreadCount > 0 ? data?.unreadCount : null}
            sx={{
              color: "#fff",
              fontSize: "9px",
              height: "15px",
              minWidth: "15px",
              padding: "2px",
              top: "0px",
              right: "0px",
            }}
            label={<MdOutlineLocalPostOffice size={17} color="black" />}
          />
        </div>
        {/* Its showing in every case */}
        <div className="flex flex-col lg:flex-row justify-between text-[rgba(118,118,124,0.8)] my-2 text-xs font-">
          <div className="flex items-center gap-2">
            <GoCalendar size={17} />
            <span>{data?.start_date}</span>
          </div>
          {!data.is_completed && !data.trial && !!data.is_live && (
            <Tooltip title={showProgressBar ? "Hide progress bar" : "Show progress bar"} arrow>
              <span style={{ cursor: "pointer" }}>
                {showProgressBar ? (
                  <AiOutlineEyeInvisible size={22} color="black" onClick={() => setShowProgressBar(false)} />
                ) : (
                  <IoEyeOutline size={22} color="black" onClick={() => getProgressdetails(data?._id)} />
                )}
              </span>
            </Tooltip>
          )}
        </div>

        {/* Condition base show data  */}
        {data.is_live && !data.trial && !data.is_completed && showProgressBar ? (
          <div className="mt-2">
            <div className="h-[10px]">{progressPercentage?.is_live ? <ProgressBars value={progressPercentage?.percentage} /> : null}</div>
            <div className="flex justify-between mt-1">
              <p className="text-[12px] text-[#76767CCC] font-medium">{progressPercentage?.is_live ? progressPercentage?.percentage : 0}%</p>
              {progressPercentage?.currentDay ? (
                (() => {
                  const activeDays = progressPercentage.currentDay - (progressPercentage.totalLeave || 0);
                  const currentDayOfWeek = ((activeDays % 7) + 1);
                  return (
                    <p className="text-[12px] text-[#76767CCC] font-medium">
                      Week - {progressPercentage?.currentWeek} Day - {currentDayOfWeek}
                    </p>
                  );
                })()
              ) : ""}
              <p className="text-[12px] text-[#76767CCC] font-medium">
                {progressPercentage?.num_of_weeks} weeks
                {progressPercentage?.totalLeave > 0 && <span className="text-red-500 text-[10px]"> + {progressPercentage?.totalLeave} Breaks</span>}
              </p>
            </div>
          </div>
        ) : (
          !data.is_completed && null
        )}

        <div className=" mt-2 mb-4 flex md:flex-col lg:flex-row justify-between items-center ">
          {!data.is_blocked && !data.is_cancelled && data.is_live && data.is_completed ? (
            <p className="text-[10px] text-[#76767CCC] font-medium flex-1 lg:text-right md:text-center text-right md:mt-1 lg:mt-0">Completed</p>
          ) : (
            data.trial && <p className="bg-[#D9FFCC] text-[#63BE5F] text-xs font-medium rounded-md w-[91px] text-center py-[2px]">{data?.num_of_weeks} weeks</p>
          )}

          {data.is_blocked ? <p className="text-[12px] text-red-700">Blocked</p> : null}

          {data.is_blocked && data.is_cancelled ? <p className="text-[12px] text-red-700">Cancelled</p> : null}

          {!data.is_blocked && !data.is_cancelled && !data.is_live ? (
            <div className=" flex md:flex-col lg:flex-row justify-between items-center w-full">
              {data.trial ||
                (data.have_dietician && !data.is_live && (
                  <p className="bg-[#D9FFCC] text-[#63BE5F] text-xs font-medium rounded-md w-[91px] text-center py-[2px]">{data?.num_of_weeks} weeks</p>
                ))}
              {data.have_dietician ? (
                <p className="text-[10px] text-[#76767CCC] font-medium flex-1 lg:text-right md:text-center text-right md:mt-1 lg:mt-0">Your Coach will be assigned shortly</p>
              ) : (
                <p className="text-[14px] font-bold text-white pl-2 mt-[15px]">Your Program will be live soon</p>
              )}
            </div>
          ) : null}

          {!data.is_blocked && !data.is_cancelled && data.is_live && data.trial ? (
            <div>
              {data.have_dietician ? (
                <p className="text-[10px] text-[#76767CCC] font-medium flex-1 lg:text-right md:text-center text-right md:mt-1 lg:mt-0">Coach Assigned</p>
              ) : (
                <p className="text-[10px] text-[#76767CCC] font-medium flex-1 lg:text-right md:text-center text-right md:mt-1 lg:mt-0">Your Program will be live soon</p>
              )}
            </div>
          ) : null}
        </div>

        {/* chat now and manage section */}
        <div className="flex flex-col justify-between  md:gap-x-2 lg:flex-row gap-y-2 mt-1">
          <PrimaryButton css="!bg-[#20A8D8] !text-white !py-1 rounded-md !text-[12px] !font-normal w-full" title="Manage" handler={handleManage} />
          {!data.is_blocked && !data.is_cancelled && data?.coach_id != null ? (
            <PrimaryButton
              css="bg-[#FBF712] !py-1 rounded-md !text-[12px] !font-normal !px-5 w-full !text-black"
              title="Chat Now"
              handler={() => {
                if (selectedChat) {
                  if (selectedChat._id !== data._id) {
                    if (chatVisible(data?.is_completed, data?.rating)) {
                      setSelectedChat(data);
                      if (data?.unreadCount > 0) {
                        setTimeout(() => {
                          setNewMessageOn(!newMessageOn);
                        }, 1000);
                      }
                      localStorage.setItem("showChat", JSON.stringify(data));
                      localStorage.setItem("my-message", JSON.stringify([]));
                    } else {
                      setRatingPendingBox(true);
                      setRatingCardData(data);
                    }
                  }
                } else {
                  if (chatVisible(data?.is_completed, data?.rating)) {
                    setSelectedChat(data);
                    if (data?.unreadCount > 0) {
                      setNewMessageOn(!newMessageOn);
                    }
                    localStorage.setItem("showChat", JSON.stringify(data));
                    localStorage.setItem("my-message", JSON.stringify([]));
                  } else {
                    setRatingPendingBox(true);
                    setRatingCardData(data);
                  }
                }
              }}
            />
          ) : (
            <PrimaryButton
              css="bg-[#F0EFC4] !py-1 rounded-md !text-[12px] !font-normal !px-5 w-full !text-black cursor-default"
              title="Chat Now"
              handler={() => {
                // console.log("Not clicked");
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export const ChatCardCoach = ({ data, handler = () => { }, Css, icon = true }) => {
  return (
    <div className={`border rounded-[10px] border-[#979797] flex w-full  bg-[#FFFFFF] h-[39px] shadow-sm overflow-hidden my-4 border-opacity-25 ${Css}`}>
      <div className="bg-[#D9FFCC] w-[8px] "></div>
      <div className="flex-1 w-full p-2 cursor-pointer" onClick={handler}>
        <div className="flex justify-between items-center">
          <h1 className="text-sm font-semibold text-nowrap text-ellipsis overflow-hidden">{data?.name}</h1>
          {icon && <MdOutlineArrowForwardIos />}
        </div>
      </div>
    </div>
  );
};
export default ChatCard;
